import React from 'react';
import { Form, InputNumber } from 'antd';

const CountItem = ({ onChange, disabled, required, shouldUpdate }) => {
  return (
    <Form.Item shouldUpdate={shouldUpdate} name={['rules', 'count']} rules={[{ required: required, message: 'Required' }]}>
      <InputNumber disabled={disabled} style={{ width: '100%' }} onChange={onChange} min={1} />
    </Form.Item>
  );
};

export default CountItem;
